import Lottie from 'react-lottie';
import styled from 'styled-components';

interface FavoriteProps {
  isFavorited: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -8px;
`;

export const LottieWrapper = styled(Lottie)`
  display: block;
`;

export const Favorite = styled.div<FavoriteProps>`
  width: ${(props) => (props.isFavorited ? '45px' : '24px')} !important;
  height: 24px !important;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: 7px;
`;
